import { createOceanyAuth } from "@vida/oceany-auth";
import {
  getClientId,
  getCognitoDomain,
  getLoginUrl,
  getPostLogoutRedirect,
  getRedirectUri,
  getSessionBrokerUrl,
} from "./config";

export type { TokenBundle } from "@vida/oceany-auth";

const auth = createOceanyAuth({
  storageKeyPrefix: "vida_currents",
  getClientId,
  getCognitoDomain,
  getRedirectUri,
  getPostLogoutRedirect,
  getSessionBrokerUrl,
  getLoginUrl,
  loginAlertMessage: "Config OAuth mancante per Currents.",
});

export const SK_RETURN_PATH = auth.SK_RETURN_PATH;
export const {
  loadTokens,
  saveTokens,
  clearTokens,
  setRememberMe,
  getRememberMe,
  saveReturnPath,
  consumeReturnPath,
  clearOAuthSession,
  performLogout,
  startLogin,
  handleOAuthCallback,
  restoreSessionOnStartup,
  refreshIfNeeded,
  getIdToken,
  forceRefreshTokens,
  logoutUrl,
  decodeJwtPayload,
  currentUserSub,
  currentUserEmail,
  currentUserDisplayName,
  redirectToLogin,
} = auth;
